<template lang="pug">
    a(v-if="path || href" :href="finalLink" :target="target")
      .box-wrap
        .box
          .post-image(v-if="image" ref="container")
            figure
              img.w-full.bject-cover.h-auto(
                  v-lazy="image"
                  rel="noopener"              
                  )
        h3.title {{panel.title}} 
    .no-link(v-else)
      .box-wrap
        .box
          .post-image(v-if="image" ref="container")
            figure
              img.w-full.bject-cover.h-auto(
                  v-lazy="image"
                  rel="noopener"              
                  )
        h3.title {{panel.title}} 
</template>

<script>
import { get, trim, startsWith } from '@/helpers';

export default {
  name: 'Panel',
  mounted() {
    if (this.id) {
      const state = this.getCollapseState();
      if (state) {
        this.isCollapsed = state[this.id];
      }
    }
  },
  data() {
    return {
      delay: 150,
      mouseover: false,
      isCollapsed: true,
      width: 320,
      height: 320
    };
  },
  props: {
    panel: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    maxWidth: {
      type: Number
    }
  },
  computed: {
    image() {
      const image = get(this.panel, 'images.0');
      if (!image) return false;

      const storageRoute = trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        '/'
      );

      let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
      const parameters = {
        // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
        // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
        // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
        ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
        ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
      };
      let { w, h } = parameters;
      let { width, height } = image;
      let aspectRatio = width / height;

      if (w && h) {
        aspectRatio = 1;

        h = 320;
        w = h * aspectRatio;
        fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${w}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${h}`);
      } else if (!w && !h) {
        h = 320;
        w = h * aspectRatio;
        fit += `&h=${h}&w=${w}`;
      }
      return {
        h,
        w,
        src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
        error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`
      };
    },
    hyperlink() {
      return get(this.panel, 'hyperlink') || {};
    },
    href() {
      let href = false;

      if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
        const link = this.hyperlink.href;
        switch (this.hyperlink.type) {
          case 'external':
            if (!startsWith(link, 'https://') && !startsWith(link, 'http://')) href = `https://${link}`;
            else href = link;
            break;

          case 'mailto':
            href = `mailto:${link}`;
            break;

          case 'tel':
            href = `tel:${link}`;
            break;
        }
      }

      return href;
    },
    target() {
      return get(this.hyperlink, 'target') || '_self';
    },
    path() {
      if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
        return this.hyperlink.menuItem.path;
      else return false;
    },
    finalLink() {
      if (this.path) {
        return this.path;
      } else if (this.href) {
        return this.href;
      } else {
        return false;
      }
    }
  },
  methods: {
    hover() {
      this.$emit('focus', this.item);
      this.mouseover = true;
    },
    blur() {
      setTimeout(() => {
        this.$emit('blur', this.item);
        this.mouseover = false;
      }, this.delay);
    }
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"


.box-wrap
  transition: all .3s ease-in-out 0s
  a &:hover
    transform: scale(1.05)
  .box
    @apply flex p-4 justify-center items-center shadow-md
    .post-image
      max-width: 150px
  .title
    @apply uppercase text-center font-semibold pt-3 break-all
    color: $isserstedt-blue2
</style>
